import React from "react";
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import "./diagnosis.scss";
const DiagnosisInformation = (props) => {
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))
    const intitalState = {
            diagnosisName: "",
            diagnosisCode: "",
            icdCode: "",
            activeStatus: true,
            CreatedBy: getUserValue?.uniqueID
    }

    let location = useLocation();
    const navigate = useNavigate();
    const { submitDiagnosisInfo } = props
    const [diagnosisInfoInputFields, setdiagnosisInfoInputFields] = React.useState(intitalState);

    const handleDoctorhInfoInputChange = (event) => {
        const { name, value } = event.target;
        setdiagnosisInfoInputFields((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }
    const handleGoBack = () => {
        navigate("/master/diagnosis", { state: { addPatient: false, rowData: {} } })
    }
   const handleDiagnosis = (event, diagnosisInfoInputFields) => {
    submitDiagnosisInfo(event, diagnosisInfoInputFields)
    setdiagnosisInfoInputFields(intitalState)
   }
    return (
        <>
            
            <form>
                <div className="diagnosis-info" >
                    <div className="mt-2 ml-4">
                        <h4>Diagnosis Information</h4>
                        <div className="back-btn" onClick={handleGoBack}>
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Diagnosis Name*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-diagnoses"></i></div>
                                    </div>
                                    <input type="text"
                                        className="form-control"
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        placeholder="Diagnosis Name" 
                                        name="diagnosisName" 
                                        value={diagnosisInfoInputFields?.diagnosisName} 
                                        onChange={handleDoctorhInfoInputChange} required />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Diagnosis Code*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text" className="form-control" 
                                        placeholder="Diagnosis Code" name='diagnosisCode' 
                                        value={diagnosisInfoInputFields?.diagnosisCode} 
                                        onChange={handleDoctorhInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Icd Code*</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-code-branch"></i></div>
                                    </div>
                                    <input
                                        type="text" 
                                        className="form-control" id="lname" 
                                        placeholder="Icd Code" name="icdCode" 
                                        value={diagnosisInfoInputFields?.icdCode} 
                                        onChange={handleDoctorhInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2" onClick={(event) => handleDiagnosis(event, diagnosisInfoInputFields)}>Add Diagnosis</Button>
                </div>
            </form>
        </>
    );
};

export default DiagnosisInformation; 